import { RouteHelper } from '@ers/helpers';
import { useRouter } from '.';

const useBuildMenuItem = (type) => {
    const { location } = useRouter();
    const activeByUrl = RouteHelper.getActiveItemByPath(location.pathname);
    const activeByType = RouteHelper.getItemByType(type);
    const { url, onClick } = activeByType;
    const isActive = activeByUrl && activeByUrl.type === type;
    return [url(), onClick, isActive];
};
export default useBuildMenuItem;
